import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

export default function Navbar(props) {
    return (
        <nav className={`navbar navbar-expand-lg navbar-${props.mode} bg-${props.mode}`}>
            <div className="container-fluid">
                <Link className="navbar-brand" to="/">{props.title}</Link>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                        <li className="nav-item">
                            <Link className="nav-link" aria-current="page" to="/">Home</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/About">{props.about}</Link>
                        </li>
                    </ul>

                    {/* d-flex = display-flex */}
                    {/* onClick needs only a function(eg. toggleMode) and not a function call therefore gave a arrow-func which has a function call */}
                    <div className="d-flex">
                        {/* <input type="color" className="form-control form-control-color mx-2" id="exampleColorInput" value="#563d7c" title="Choose your color" /> */}

                        {/* <div className="bg-primary rounded mx-2" onClick={()=>{props.toggleMode("primary")}} style={{height:"30px", width:"30px", cursor:"pointer", borderRadius:"500px"}} ></div> */}

                        <a href="#" className="btn btn-primary active rounded" data-bs-toggle="button" autocomplete="off" onClick={() => { props.toggleMode("primary") }} style={{ height: "30px", width: "30px", cursor: "pointer", borderRadius: "500px" }}></a>

                        <div className="bg-danger rounded mx-2" onClick={() => { props.toggleMode('danger') }} style={{ height: "30px", width: "30px", cursor: "pointer" }} ></div>
                        <div className="bg-success rounded mx-2" onClick={() => { props.toggleMode('success') }} style={{ height: "30px", width: "30px", cursor: "pointer" }} ></div>
                        <div className="bg-warning rounded mx-2" onClick={() => { props.toggleMode('warning') }} style={{ height: "30px", width: "30px", cursor: "pointer" }} ></div>
                        <div className="bg-light rounded mx-2" onClick={() => { props.toggleMode('light') }} style={{ height: "30px", width: "30px", cursor: "pointer", border: "1px solid black" }} ></div>
                        <div className="bg-dark rounded mx-2" onClick={() => { props.toggleMode('dark') }} style={{ height: "30px", width: "30px", cursor: "pointer", border: "1px solid white" }} ></div>
                    </div>

                    {/* if light mode then do dark or else keep it light only, used ternary operator. */}
                    <div className={` text-${props.mode === "light" ? "dark" : "light"}`}>
                        {/* <input className="form-check-input" onClick={()=>{props.toggleMode(null)}} type="checkbox" role="switch" id="flexSwitchCheckDefault" /> */}
                        <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Toggle color mode</label>
                    </div>
                </div>
            </div>
        </nav>
    )
}

Navbar.propTypes = {
    title: PropTypes.string.isRequired,
    about: PropTypes.string
}

Navbar.defaultProps = {
    title: "Set Title here",
    about: "Set About here"
}